module.exports = __webpack_public_path__ + "img/footer-bg-branco.90666063.svg";